export default (editorState) => {
    if (!editorState) return true;

    const contentState = editorState.getCurrentContent();

    return !contentState.hasText();
};
